import { Linking } from 'react-native';
import { InAppBrowser } from 'react-native-inappbrowser-reborn';
import WebView from 'react-native-webview';

import { IPostEventMessage } from '@webtrader/core/chart/events';
import { formatMobileUrl } from '@webtrader/core/format/url';
import { isEmpty } from '@webtrader/core/validators';
import { checkIsNative } from '@webtrader/core/validators/device';

const IS_NATIVE = checkIsNative();

export const openInAppBrowser = async (url?: string | null | undefined) => {
  const redirectUrl = formatMobileUrl(url);
  if (!(redirectUrl && !isEmpty(redirectUrl))) {
    return false;
  }

  if (!IS_NATIVE) {
    // https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari/70463940#70463940
    // Required when we use window.open in functions when using Safari
    setTimeout(() => window.open(redirectUrl, '_blank'));
    return false;
  }

  if (await InAppBrowser.isAvailable()) {
    InAppBrowser.open(redirectUrl, {
      showInRecents: true,
      animated: true,
      showTitle: false,
      // For iOS:
      dismissButtonStyle: 'close',
      preferredBarTintColor: 'transparent',
      preferredControlTintColor: 'white',
      readerMode: false,
      modalPresentationStyle: 'pageSheet',
      modalTransitionStyle: 'coverVertical',
      modalEnabled: true,
      enableBarCollapsing: true,
      // For Android:
      toolbarColor: 'transparent',
      secondaryToolbarColor: 'white',
      navigationBarColor: 'transparent',
      navigationBarDividerColor: 'white',
      enableUrlBarHiding: true,
      enableDefaultShare: false,
      forceCloseOnRedirection: false,
      animations: {
        startEnter: 'slide_in_right',
        startExit: 'slide_out_left',
        endEnter: 'slide_in_left',
        endExit: 'slide_out_right'
      }
    });
  } else {
    Linking.openURL(redirectUrl);
  }

  return false;
};

export const postNativeEventMessage = (webView: WebView, message: IPostEventMessage) => {
  // check out this site
  // https://github.com/react-native-webview/react-native-webview/releases/tag/v5.0.0
  const postScript = `
    window.postMessage(${JSON.stringify(message)});

    true;
  `;

  if (webView) {
    webView.injectJavaScript(postScript);
  }
};
